module.exports = __webpack_public_path__ + "media/images/hero-banner1-d32992c9b2eb376e0342e16c47da4607.jpg";